var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.label))]),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }